import React from "react";

// Uploaded LCTX informational infographics shown below the product hero video.
const IMAGES = [
  "https://media.base44.com/images/public/68e21bb4c1e25d4ab005735e/18d5c095b_07d025b5-4a92-44dd-a995-e4b57401816a.png",
  "https://media.base44.com/images/public/68e21bb4c1e25d4ab005735e/0246726f9_78e0b265-9105-41f5-bb9a-d577a00488f4.png",
  "https://media.base44.com/images/public/68e21bb4c1e25d4ab005735e/b6b2571f5_224feb32-9c3b-40d2-8599-0230ca3e13e9.png",
  "https://media.base44.com/images/public/68e21bb4c1e25d4ab005735e/77cb71ec8_aa79dc0c-c526-4ae9-9a0b-4e8a0426564a.png",
  "https://media.base44.com/images/public/68e21bb4c1e25d4ab005735e/fdb70633e_b63c1558-1485-4e59-8113-b7b1de9c6728.png",
  "https://media.base44.com/images/public/68e21bb4c1e25d4ab005735e/65ee16372_baeac303-e516-4fb1-87bb-3c51d1116794.png",
  "https://media.base44.com/images/public/68e21bb4c1e25d4ab005735e/e9a379cd8_c03b897a-ba0c-41c3-96e9-a9b58d36d862.png",
  "https://media.base44.com/images/public/68e21bb4c1e25d4ab005735e/79fc5eec4_d499d04a-e1d5-40e2-9d99-b16e39962627.png",
];

export default function ProductInfographics() {
  return (
    <section className="mb-8 md:mb-12">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6">
        {IMAGES.map((src, i) => (
          <div
            key={i}
            className="rounded-lg overflow-hidden shadow-md border border-gray-200 bg-white"
          >
            <img
              src={src}
              alt={`LCTX Tyre Changer info ${i + 1}`}
              className="w-full h-auto block"
              loading="lazy"
              decoding="async"
              onError={(e) => {
                e.currentTarget.style.visibility = "hidden";
              }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}